import React from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Checkbox,
    FormControlLabel,
    TextField,
    InputAdornment,
    Typography,
    Box,
    Select,
    FormControl,
    MenuItem,
    InputLabel,
} from "@material-ui/core";
import { useClasses } from "../../../config/theme";

import { MATERIAL_UI_PROPS } from "../../../lib/data";
import servicesData from "../../../datasource/schema/services.json";

export const servicesRenderer = (
    values,
    name,
    fieldUpdateHandler,
    mutable,
    defaultValues,
    serviceCategories,
    unusedServicesHidden,
) => {
    const classes = useClasses();
    let formattedValues = {};
    let idxList = [];
    let renderValuesEl = [];

    const ndsValues = servicesData.nds.values;
    const ndsItems = Object.entries(ndsValues).map(([value, label]) => (
        <MenuItem key={value} value={Number(value)}>
            {label}
        </MenuItem>
    ));

    if (values && Array.isArray(values) && values.length > 0) {
        values.forEach((val) => {
            const includedInRate = val.pivot
                ? val.pivot.included
                : val.included;
            return (formattedValues[val.id] = {
                included: includedInRate,
                price: val.pivot.price > 0 ? val.pivot.price : val.price,
                nds: val.pivot.nds ?? val.nds,
                ...(val.pivot.child_price && {
                    child_price: val.pivot.child_price,
                }),
            });
        });
    } else {
        formattedValues = { ...values };
    }

    idxList = Object.keys(formattedValues).map((key) => +key);

    if (defaultValues?.length > 0) {
        const valuesToShow = unusedServicesHidden.unusedServicesHidden
            ? defaultValues.filter((defValue) => idxList.includes(defValue.id))
            : defaultValues;

        var sortServiceCategories = [];
        serviceCategories?.forEach((s) => {
            let obj = {};
            obj.id = s.id;
            obj.name = s.name;
            obj.data = [];
            sortServiceCategories[s.order] = obj;
        });
        sortServiceCategories?.sort();

        valuesToShow?.forEach((v) => {
            sortServiceCategories.forEach((ssc, i) => {
                if (v.service_category_id == ssc.id) {
                    sortServiceCategories[i].data.push(v);
                }
            });
        });

        sortServiceCategories?.map((cat) => {
            if (cat.data.length > 0) {
                renderValuesEl.push(
                    cat.data.map((defValue) => {
                        let curPickedVal;
                        let includedInRate = 0;

                        if (idxList.includes(defValue.id)) {
                            curPickedVal = {
                                [defValue.id]: formattedValues[defValue.id],
                            };
                            includedInRate =
                                formattedValues[defValue.id].included;
                        }

                        const curNds = curPickedVal?.[defValue.id]?.nds
                            ? curPickedVal[defValue.id].nds
                            : defValue.nds;

                        const curPrice = curPickedVal?.[defValue.id]?.price
                            ? curPickedVal[defValue.id].price
                            : defValue.price;

                        const curChildPrice = curPickedVal?.[defValue.id]
                            ?.child_price
                            ? curPickedVal[defValue.id].child_price
                            : defValue.child_price;

                        return (
                            <TableRow key={defValue.id}>
                                <TableCell style={{ font: "caption" }}>
                                    {cat.name}
                                </TableCell>
                                <TableCell>{defValue.name}</TableCell>
                                <TableCell>
                                    <FormControlLabel
                                        disabled={!mutable}
                                        key={defValue.id}
                                        checked={idxList.includes(defValue.id)}
                                        value={curPrice}
                                        control={
                                            <Checkbox
                                                name={defValue.id.toString()}
                                                color={
                                                    MATERIAL_UI_PROPS.colors
                                                        .primary
                                                }
                                                onChange={(e) =>
                                                    changeIncludedHandler(
                                                        name,
                                                        e.target.value,
                                                        defValue.id,
                                                        fieldUpdateHandler,
                                                        formattedValues,
                                                    )
                                                }
                                            />
                                        }
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormControlLabel
                                        disabled={!mutable}
                                        key={defValue.id}
                                        checked={!!includedInRate}
                                        value={curPrice}
                                        control={
                                            <Checkbox
                                                name={defValue.id.toString()}
                                                color={
                                                    MATERIAL_UI_PROPS.colors
                                                        .primary
                                                }
                                                onChange={(e) =>
                                                    handleChange(
                                                        name,
                                                        e.target.value,
                                                        defValue.id,
                                                        fieldUpdateHandler,
                                                        formattedValues,
                                                        !includedInRate,
                                                    )
                                                }
                                            />
                                        }
                                    />
                                </TableCell>

                                <TableCell>
                                    <FormControl
                                        sx={{ width: 100 }}
                                        size="small"
                                    >
                                        <Select
                                            disabled={!mutable}
                                            value={curNds}
                                            variant={
                                                MATERIAL_UI_PROPS.varinats
                                                    .outlined
                                            }
                                            onChange={(e) =>
                                                handleChange(
                                                    name,
                                                    e.target.value,
                                                    defValue.id,
                                                    fieldUpdateHandler,
                                                    formattedValues,
                                                    includedInRate,
                                                    "nds",
                                                )
                                            }
                                        >
                                            {ndsItems}
                                        </Select>
                                    </FormControl>
                                </TableCell>

                                <TableCell>
                                    <TextField
                                        disabled={!mutable}
                                        value={curPrice}
                                        variant={
                                            MATERIAL_UI_PROPS.varinats.outlined
                                        }
                                        size={MATERIAL_UI_PROPS.sizes.small}
                                        type="number"
                                        onChange={(e) =>
                                            handleChange(
                                                name,
                                                e.target.value,
                                                defValue.id,
                                                fieldUpdateHandler,
                                                formattedValues,
                                                includedInRate,
                                                "price",
                                            )
                                        }
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    &#8381;
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </TableCell>
                                {(defValue.calculation_mode === "per-guest" ||
                                    defValue.calculation_mode ===
                                        "per-person" ||
                                    defValue.calculation_mode ===
                                        "per-guest-nobaby" ||
                                    defValue.calculation_mode ===
                                        "per-guest-all-child") && (
                                    <TableCell>
                                        <TextField
                                            disabled={!mutable}
                                            value={curChildPrice}
                                            variant={
                                                MATERIAL_UI_PROPS.varinats
                                                    .outlined
                                            }
                                            size={MATERIAL_UI_PROPS.sizes.small}
                                            type="number"
                                            onChange={(e) =>
                                                handleChange(
                                                    name,
                                                    e.target.value,
                                                    defValue.id,
                                                    fieldUpdateHandler,
                                                    formattedValues,
                                                    includedInRate,
                                                    "child_price",
                                                )
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        &#8381;
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </TableCell>
                                )}
                            </TableRow>
                        );
                    }),
                );
            }
        });
    }

    return (
        <React.Fragment>
            {renderValuesEl?.length > 0 ? (
                <React.Fragment>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Категория услуги</TableCell>
                                <TableCell>Название</TableCell>
                                <TableCell>Включен в тариф</TableCell>
                                <TableCell>Добавить к стоимости</TableCell>
                                <TableCell>НДС</TableCell>
                                <TableCell>Цена</TableCell>
                                <TableCell>Цена за ребенка</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{renderValuesEl.map((r) => r)}</TableBody>
                    </Table>
                </React.Fragment>
            ) : (
                <Typography>Нет дополнительных услуг</Typography>
            )}
            {defaultValues?.length > idxList.length && (
                <Box
                    key={defaultValues?.length}
                    mt={1}
                    display="flex"
                    justifyContent="flex-end"
                >
                    <Typography
                        className={classes.toggle}
                        onClick={
                            unusedServicesHidden.toggleUnusedServicesHandler
                        }
                    >
                        {`${
                            unusedServicesHidden.unusedServicesHidden
                                ? "Развернуть"
                                : "Свернуть"
                        } не включенные в тариф услуги`}
                    </Typography>
                </Box>
            )}
        </React.Fragment>
    );
};

// Helper funcs

const handleChange = (
    fieldName,
    price,
    serviceId,
    fieldUpdater,
    curValues,
    included,
    propName,
) => {
    const priceNum = +price;
    const updatedCurValues = { ...curValues };

    updatedCurValues[[serviceId]] = {
        ...curValues[serviceId],
        included: included,
        ...(propName && { [propName]: priceNum }),
    };

    fieldUpdater(fieldName, { ...updatedCurValues });
};

const changeIncludedHandler = (
    fieldName,
    price,
    serviceId,
    fieldUpdater,
    curValues,
) => {
    const updatedCurValues = { ...curValues };
    const strServiceId = serviceId.toString();
    const servicesInValuesIdx = Object.keys(updatedCurValues);

    if (servicesInValuesIdx.includes(strServiceId)) {
        Reflect.deleteProperty(updatedCurValues, [strServiceId]);
    } else {
        updatedCurValues[strServiceId] = { included: 0, price: +price };
    }

    fieldUpdater(fieldName, { ...updatedCurValues });
};
